(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name SolicitudasesoController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('SolicitudasesoController', SolicitudasesoController);

    SolicitudasesoController.$inject = ["GenerallabService","PedidoService","AsesoramientoService","StripeService","VideoconsultaService","$uibModal","UserService","$timeout","$location","Upload"];

    function SolicitudasesoController(GenerallabService,PedidoService,AsesoramientoService,StripeService,VideoconsultaService,$uibModal,UserService,$timeout,$location,Upload){

      var vm = this;
      vm.titulo = "";
      vm.descripcion = "";
      vm.stripe = StripeService;
      vm.nuevoAsesoramiento = 0;
      vm.pedido = 0;
      vm.ficheros = [];
      vm.filesLength = 0;
      vm.asesoramientoActivo_id ="";
      vm.loading = false;
      vm.card =  false;
      vm.pago_realizado = false;
      vm.estado_id =3352;
      vm.activo = false;
      vm.buscador = "";
      vm.error = false;
      vm.success = false;
      vm.generalLab = GenerallabService;
      vm.horasFinal = [{
        fecha:'09-11-2021',
        horas:['12:00','12:30'],
        rechazado:false
      }];
      vm.limit = 0;

        vm.getAsesoramientos = function(limit){
          if(typeof(limit)!='undefined'){
            vm.limit = 5;
          }
          AsesoramientoService.GetAsesoramientos(vm).then(function(data){ 
              vm.asesoramientos = data.asesoramientos;  
           })
        } 

        vm.crearAsesoramiento = function(form){
          if (!form.$valid) {
              vm.success = false;
                angular.element("[name='" + form.$name + "']").find('.ng-invalid:visible:first').focus();
                return false;
          }
          vm.loading = true;
          vm.nuevoAsesoramiento = vm.nuevoAsesoramiento - 1;
            AsesoramientoService.SaveAsesoramiento(vm).then(function(data){
                vm.loading = false;
                  vm.titulo = "";
                  vm.descripcion = "";
                  vm.archivos ="";
                  vm.estado_id =3352;
                  vm.asesoramientos = data.asesoramientos;
                  vm.generalLab.numAsesoramientosCentro++;
                  vm.ficheros = [];
                  vm.getAsesoramientoactivo(data.nuevo_asesoramiento[0].id);
                  //console.log(vm.generalLab.centro.packs);
                  //console.log(vm.generalLab.numAsesoramientosCentro);
            })
        }

        vm.nuevoMensaje = function(form){
            vm.loading = true;
            AsesoramientoService.GetChat(vm).then(function(data){
                  vm.mensaje = "";
                  vm.fecha =data.fecha;
                  vm.archivos_chat = "";
                  vm.ficheros = [];
                  vm.getAsesoramientoactivo(vm.asesoramiento_activo.id);
                vm.loading = false;
             })
        }

        vm.getAsesoramientoactivo = function(asesoramiento_id){
          vm.loading = true;
            AsesoramientoService.GetMensajesAsesoramiento(asesoramiento_id).then(function(data){
              vm.mensajes = data.mensajes;
              vm.asesoramiento_activo = data.asesoramiento_activo;
              vm.activo = true;
                vm.visualizarAsesoramientoVisible=true;
                $timeout(function(){
                  $('.mensajesDiv').animate({scrollTop:$('.mensajesDiv').height()}, 400, 'swing', function() { 
                  });
                  console.log("intentando bajar");
                },100)
          vm.loading = false;


              //console.log(data.asesoramiento_activo);
            })
        }


        vm.uploadFiles = function (files) { 
            if (files && files.length) {
              for (var i = 0; i < files.length; i++) {
                Upload.upload({
                      url: '/ajax/subirdocumentacion',
                      data: { file: files[i] }
                  }).then(function (resp) {
                      //console.log(resp);
                      vm.ficheros.push(resp.data);

                     if (vm.ficheros) {
                      console.log(vm.filesLength = vm.filesLength + 1);
                      console.log(vm.filesLength);
                     }
                  }, function (resp) {
                      //console.log('Error status: ' + resp.status);
                  }, function (evt) {
                      var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                      //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                  });
              }
              //files = null;

            }
        }

        vm.historialconsultas = function(date){
          VideoconsultaService.getVideoConsultas(vm).then(function(data){ 
              vm.videoconsultasList = data.videoconsultas;  
          })
        }

        vm.getUrlVars = function() {
          var vars = {};
          var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
              vars[key] = value;
          });
          return vars;
        }


        vm.comprobarParams = function(){
            //var url_string = $window.location.href; 
            //var url = new URL(url_string);
            vm.params = vm.getUrlVars();
            if(vm.params.chat_id){
              vm.getAsesoramientoactivo(vm.params.chat_id);
            }
            console.log("params",vm.params);
        }
        vm.comprobarParams();

        

        /*vm.orderComplete = function(result){
            PedidoService.finalizarPedidoAsesoramiento(result,vm.stripe).then(function(data){ 
                vm.generalLab.centro.packs = data.packs;
                vm.pago_realizado = true;
           })
        }*/

        /*vm.pedidoSolicitado = function(){
          console.log("solicitando");
            vm.card = true;
            vm.pedido = 0;
            //vm.stripe.init();
            vm.stripe.setAmount(10);
            vm.stripe.setProductId(vm.selectedProductId);
            //vm.stripe.pedido = data;  
        }*/

        /*vm.open = function () {
          //zone to inject html modal
         

          var modalInstance = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'compra',
            controller: function($scope, $timeout ){
              $scope.ac = vm;
              $timeout(function() {
                 vm.stripe.init()
              }, 10);
             
            },
            size: 'lg',
            //appendTo: parentElem,
            //Wait to end a ajax call;
            
          });
        };  */


    }  

})();